import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateSingleLotMinimumBidDecrement } from "../../../redux/action/liveRoom";
import { ClipLoader } from "react-spinners";
import { notifyError } from "../../../helper/helpers";
import SingleProductLotDetail from "./SingleProductLotDetail";


function UpdateMaximumProductBid({
  singleOfferData,
  offerDetailLoading = false,
  setIsOpenUpdateBid,
  checkFirstBid
}) {
  const dispatch = useDispatch();
  const [minimumBidDecrease, setMinimumBidDecrease] = useState(0);
  const { minimumBidUpdateLoading } = useSelector((state) => state.liveAuction);

  useEffect(() => {
    setMinimumBidDecrease(singleOfferData?.minimumBidDecrease);
  }, [singleOfferData]);

  const handleSubmitMaximumBid = () => {
    if (checkFirstBid) {
      return notifyError("You can't update minimum bid after bidding started.");
    }

    dispatch(
      updateSingleLotMinimumBidDecrement(
        singleOfferData?.auction,
        singleOfferData?._id,
        minimumBidDecrease
      )
    ).then(() => {
      setIsOpenUpdateBid(false);
    });
  };

  return (
    <div className="mt-1">
      <SingleProductLotDetail
        singleOfferData={singleOfferData}
        offerDetailLoading={offerDetailLoading}
        tagLotNumber={true}
      />

      <span className="flex column gap-1 mt-2">
        <span>
          <p>
            Update Maximum Bid <span className=" red-text">*</span>
          </p>
          <input
            type="number"
            name="minimumBidDecrease"
            value={minimumBidDecrease}
            placeholder="Enter update maximum bid amount"
            className="input-tag-style input-width"
            onChange={(e) => setMinimumBidDecrease(e.target.value)}
          />
        </span>
        <div className="valign-wrapper justify-center">
          <button
            className="button-style pointer font-16px white-text red"
            style={{ padding: "8px 10px", width: "150px" }}
            onClick={handleSubmitMaximumBid}
            disabled={minimumBidDecrease <= 0 || minimumBidUpdateLoading}
          >
            {minimumBidUpdateLoading ? (
              <ClipLoader color="green" size={20} />
            ) : (
              "Submit"
            )}
          </button>
        </div>
      </span>
    </div>
  );
}

export default UpdateMaximumProductBid;
